
export const getListOfRcsBotConfigs = {
  GET_LIST_OF_RCS_BOT_CONFIGS_REQUEST: 'GET_LIST_OF_RCS_BOT_CONFIGS_REQUEST',
  GET_LIST_OF_RCS_BOT_CONFIGS_SUCCESS: 'GET_LIST_OF_RCS_BOT_CONFIGS_SUCCESS',
  GET_LIST_OF_RCS_BOT_CONFIGS_FAILURE: 'GET_LIST_OF_RCS_BOT_CONFIGS_FAILURE'
}

export const addRcsBotConfig = {
    ADD_RCS_BOT_CONFIG_REQUEST: "ADD_RCS_BOT_CONFIG_REQUEST",
    ADD_RCS_BOT_CONFIG_SUCCESS: "ADD_RCS_BOT_CONFIG_SUCCESS",
    ADD_RCS_BOT_CONFIG_ERROR: "ADD_RCS_BOT_CONFIG_ERROR",
  };

  export const updateRcsBotConfig = {
    UPDATE_RCS_BOT_CONFIG_REQUEST: "UPDATE_RCS_BOT_CONFIG_REQUEST",
    UPDATE_RCS_BOT_CONFIG_SUCCESS: "UPDATE_RCS_BOT_CONFIG_SUCCESS",
    UPDATE_RCS_BOT_CONFIG_ERROR: "UPDATE_RCS_BOT_CONFIG_ERROR",
  };

  export const deleteRcsBotConfig = {
    DELETE_RCS_BOT_CONFIG_REQUEST: "DELETE_RCS_BOT_CONFIG_REQUEST",
    DELETE_RCS_BOT_CONFIG_SUCCESS: "DELETE_RCS_BOT_CONFIG_SUCCESS",
    DELETE_RCS_BOT_CONFIG_ERROR: "DELETE_RCS_BOT_CONFIG_ERROR",
  };
